/*
*  用于页面的一些宽度等基础配置
 */

export default {
  namespaced: true,
  state: {
      left: 300,
      routerEntering: false,
      isOpen: false, // 是否打开商城
  },
  mutations: {
      setRouterEntering(state, val) {
          state.routerEntering = val
      },
      updateLeft(store, payload) {
          store.content.left += payload;
      },
      setIsOpen(state, val) {
          state.isOpen = val;
      }
  },
  actions: {
      updateLeft({ commit }, payload) {
          commit('updateLeft', payload);
      }
  }
};
